// extracted by mini-css-extract-plugin
export default {"tasks":"hL-z","task":"iL-z","svg":"jL-z","text":"kL-z"};